import { AppLink } from 'mydish-ui-util';
import * as React from 'react';

interface SearchSuggestionsProps {
  suggestions: string[];
  selectedSuggestionIndex: number;
  onClick?: Function;
  queryParam?: string;
  floatingSearch?: boolean;
}

export default function SearchSuggestions(props: SearchSuggestionsProps) {
  const { queryParam = '/search?q=' } = props;
  const items = props.suggestions.map((item, index) => (
    <li
      role="presentation"
      key={item}
      className={props.selectedSuggestionIndex === index ? 'active' : ''}
      onMouseDown={(e: any) => {
        if (props.onClick !== undefined) {
          props.onClick({
            ...e,
            target: { ...e.target, selectedValue: item }
          });
        }
      }}
    >
      {props.floatingSearch ? (
        <AppLink href={`${queryParam}${item}`} key={item}>
          {item}
        </AppLink>
      ) : (
        item
      )}
    </li>
  ));

  return <ul className="autoComplete_list">{items}</ul>;
}
